module.exports = __webpack_public_path__ + "img/ban-view.39663ab8.svg";